export const serviceSettingsConstants = {


  GET_SERVICE_SETTINGS_LIST_REQUEST: "GET_SERVICE_SETTINGS_LIST_REQUEST",
  GET_SERVICE_SETTINGS_LIST_SUCCESS: "GET_SERVICE_SETTINGS_LIST_SUCCESS",
  GET_SERVICE_SETTINGS_LIST_FAILURE: "GET_SERVICE_SETTINGS_LIST_FAILURE",

  GET_SERVICE_SETTINGS_REQUEST: "GET_SERVICE_SETTINGS_REQUEST",
  GET_SERVICE_SETTINGS_SUCCESS: "GET_SERVICE_SETTINGS_SUCCESS",
  GET_SERVICE_SETTINGS_FAILURE: "GET_SERVICE_SETTINGS_FAILURE",

  UPDATE_SERVICE_TYPES_REQUEST: "UPDATE_SERVICE_TYPES_REQUEST",
  UPDATE_SERVICE_TYPES_SUCCESS: "UPDATE_SERVICE_TYPES_SUCCESS",
  UPDATE_SERVICE_TYPES_FAILURE: "UPDATE_SERVICE_TYPES_FAILURE",

  UPDATE_SERVICE_STATUS_REQUEST: "UPDATE_SERVICE_STATUS_REQUEST",
  UPDATE_SERVICE_STATUS_SUCCESS: "UPDATE_SERVICE_STATUS_SUCCESS",
  UPDATE_SERVICE_STATUS_FAILURE: "UPDATE_SERVICE_STATUS_FAILURE",

};
